import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "./pages/layout/Layout";
import ResetPassword from "./pages/resetpassword/ResetPassword";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import ForgotPassword from "./pages/forgotpassword/ForgotPassword"; 
import ImportData from "./pages/importdata/ImportData";
import ReferenceData from "./pages/referencedata/ReferenceData";
import DataSelection from "./pages/dataselection/DataSelection";
import DataProcessing from "./pages/dataprocessing/DataProcessing.jsx";
// import DataProcessing from "./pages/dataprocessingBkp/DataProcessing.jsx";
import History from "./pages/history/History.jsx";
import Reports from "./pages/report/Report";
import ChangePassword from "./pages/changepassword/ChangePassword.jsx";
import DelistedEntity from "./pages/delisted-entity/DelistedEntity.jsx";

function App() {
  const Protected = ({ children }) => {
    const isLoggedIn = localStorage.getItem("loggedIn");
    return isLoggedIn ? children : <Navigate to="/login" replace />;
  };
  return (
       <div>
       <BrowserRouter>
      <Routes>

        {/* Public Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login  />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />

        {/* Protected Routes */}
        <Route  path="/"element={ <Protected> <Layout /></Protected>}>
            <Route path="/home" element={<Home />} />
            <Route path="/import" element={<ImportData />} />
            <Route path="/reference-data" element={<ReferenceData />} />
            <Route path="/data-selection" element={<DataSelection />}/>
            <Route path="/data-processing" element={<DataProcessing />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/history" element={<History />} />
            <Route path="/delisted-entity" element={<DelistedEntity />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
